<template>
  <Header :class="[addClass,appearClass]"></Header>
</template>


<script>
export default {
  data() {
    return {
      scrollY: window.pageYOffset,
      addClass: "-home",
      appearClass: "",
      boder: 0,
    };
  },
  methods: {
    handleScroll: function () {
      this.scrollY = window.pageYOffset;
      //console.log(this.border);
      if (this.scrollY >= this.border) {
        this.appearClass = "-appear";
      } else {
        this.appearClass = "";
      }
    }
  },
  mounted: function () {
    
    // ビュー全体がレンダリングされた後にのみ実行されるコード
    window.addEventListener("resize", this.handleResize);
    window.addEventListener("scroll", this.handleScroll);
    let obj = document.getElementById("homeTopCenter");
    this.border = obj.offsetTop + obj.offsetHeight;

    // this.border = document
    //     .getElementById("homeTopCenter")
    //     .getBoundingClientRect();
        
  },
  beforeDestroy: function () {
    window.removeEventListener("resize", this.handleResize);
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
